<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >  
            <router-link :to="{ name: 'Category_en'}" > 英文版類別管理</router-link> > 
            <span>英文版類別管理{{mode}}</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">英文版類別管理{{mode}}</h1>

            <!-- DataTales Example -->
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                <button type="button" class="btn btn-primary" v-on:click="Update" v-if="is_edit ">儲存</button>
                <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
              </div>
              <div class="card-body">
                <form>
                    <div class="form-group" v-if="!is_createNewSection">
                        <label for="section">單元</label>
                        <select class="custom-select" v-model="selected" :disabled="is_edit"> 
                            <option v-for="(item) in datas" :key="item.id" :value="item.id">{{item.data.name}}</option>
                        </select>
                    </div>
                    <!--
                    <div class="custom-control custom-switch" v-if="!is_edit">
                        <input type="checkbox" class="custom-control-input" id="createsection" v-model="is_createNewSection">
                        <label class="custom-control-label" for="createsection">建立新單元</label>
                    </div>
                    <div class="form-group" v-if="!is_edit">
                        <input type="text" class="form-control form-control-user" :disabled="!is_createNewSection" v-model="new_section_name" placeholder="限制10字內" >
                    </div>
                    -->
                    <div class="form-group">
                        <label for="category">類別</label>
                        <input type="text" class="form-control form-control-user" id="category"  v-model="category"  >
                        <p class="remind category-p" style="font-size: 14px;">
                            <span class="remind" v-if="error.category_p">請填寫類別</span>
                            <span class="remind" v-if="error.category_e">類別不可超過1000個字</span>
                        </p>
                    </div>
                </form>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Sidebar from './shared/Sidebar'
import Topbar from './shared/Topbar'
import Footer from './shared/Footer'
import Draggable from 'vuedraggable'
export default {
  name: 'CategoryInfo',
  data () {
    return {
        section_id:this.$route.params.section_id,
        id:this.$route.params.id,
        mode:'',
        is_edit:false,
        datas:[],
        selected:'',
        category:'',
        new_section_name:'',
        is_createNewSection:false,
        error:{
            category_p:false,
            category_e:false
        }
    }
  },
  components: {
    Sidebar,Topbar,Footer,Draggable
  },
  mounted () {
    this.Switch();
    this.Get();
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'Category_enAdd'  ) {
          this.mode = '新增';
      } else {
          this.mode = '編輯';
          this.is_edit = true;
      }
    },
    UpdateOrder() {
      var vm = this;
      this.images.forEach(function(value, index, array){
        value.order = index;
      })
    },
    Get() {
        db.collection("category_en").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var data = {"id": doc.id, "data": doc.data()};
                
                this.datas.push(data);
            });
            this.datas.sort( (d1, d2) => d1.data.order - d2.data.order);
            // if no data, switch need add new section
            if ( this.datas.length == 0 ) {
                this.is_createNewSection = true;
            }

            if ( this.$route.name != 'Category_enAdd') {
                //  edit mode
                this.selected = this.section_id;
                var list = this.datas.find(x=>x.id == this.section_id).data.list;
                this.category =  list.find(x=>x.id== this.id).name;
            } else {
                // add mode
                this.selected = this.datas[0].id
            }
        });
    },
    Auth() {

        var check = true;
        
        if ( this.category == '' ) {
            $(".category-p").css("font-size","14px");
            this.error.category_p = true;
            check = false;
        }
        if ( this.category.length > 1000 ) {
            $(".category-p").css("font-size","14px");
            this.error.category_e = true;
            check = false;
        }

        if (check) return true;
        else return false;
    },
    Post() {
      
        if ( this.is_createNewSection ) {

            if (this.Auth() ) {
                var item = {
                    name: this.new_section_name,
                    list:[{name:this.category, id:1, order:1}]
                }
                db.collection("category_en").doc(this.section_id).set(item)
                .then((doc) => {
                    alert("成功!");
                    this.$router.push({name: 'Category_en'}); 
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            }
        } else {
            if (this.Auth() ) {
                this.Beforesend();

                var tmp = this.datas.find(x=>x.id=== this.selected);
                var list = JSON.parse(JSON.stringify(tmp.data.list))
                var id = this.GetID(list);
                list.push({name:this.category, id:id, order:id});
                var item = {
                    name:tmp.data.name,
                    list:list
                }

                db.collection("category_en").doc(this.selected).update(item)
                .then(() => {
                    alert("成功!");
                    this.Aftersend();
                    this.$router.push({name: 'Category_en'}); 
                }).catch((error) => {
                    console.log("Error getting document:", error);
                    this.Aftersend();
                });

               
            }
        }
      
 
    },
    GetID(list){
        list.sort( (d1, d2) => d2.id - d1.id);
        if (list.length == 0) return 1;
        else return list[0].id + 1;
    },
    Update() {

        var tmp = this.datas.find(x=>x.id=== this.selected);
        var list = JSON.parse(JSON.stringify(tmp.data.list))
        list.find(x=>x.id == this.id).name = this.category;
        
        var item = {
            name:tmp.data.name,
            list:list
        }
        if (this.Auth() ) {
            db.collection("category_en").doc(this.selected).update(item)
            .then(() => {
                alert("成功!");
                this.$router.push({name: 'Category_en'}); 
            }).catch((error) => {
                console.log("Error getting document:", error);
            });
        }

    
    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        var name = this.datas.find(x=>x.id == this.selected).data.name;
        var list = this.datas.find(x=>x.id == this.selected).data.list;
        var index = list.findIndex(x=>x.id === this.id);
        list.splice(index, 1);

        var item = {
            name:name,
            list:list
        }

        db.collection("category_en").doc(this.selected).update(item)
        .then(() => {
            alert("刪除成功!");
            this.$router.push({name: 'Category_en'}); 
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    }
  }
}
</script>
<style scoped>
label{
  cursor: pointer;
}
label span, .remind{
  color:#BE0000
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryInfoEN.vue